/* App routes outside the initial filter flow */
export const baseRoutes = {
  START: '',
  CONGRATULATIONS: 'congratulations',
  RESULTS: 'results',
};

export const destinationTraits = {
  FLIGHT_TIME: 'FT',
  TEMPERATURE: 'temp',
  LOCATION: 'loc',
  SURPRISE: 'surp',
  TEMPERATURE_PERIOD: 'tp',
};

export const destinationTraitNames = {
  [destinationTraits.FLIGHT_TIME]: 'Flight Duration',
  [destinationTraits.TEMPERATURE]: 'Temperature',
  [destinationTraits.LOCATION]: 'Location',
  [destinationTraits.SURPRISE]: 'Surprise',
  [destinationTraits.TEMPERATURE_PERIOD]: 'Temperature Period',
};

export const selectablesNames = {
  PRIMARY_CLASSIFICATIONS: 'Primary Classifications',
  SECONDARY_CLASSIFICATIONS: 'Secondary Classifications',
  HOTEL_PRODUCTS: 'Hotel Products',
  DESTINATION_TRAITS_SELECTION: 'Destination Traits',
  DESTINATION_TRAITS_DETAILS: 'Destination Details',
  CONCEPT_HOTELS: 'Concept Hotels',
  RATING: 'Rating',
  NUMBER_OF_ADULTS: 'Number of Adults',
  NUMBER_OF_CHILDREN: 'Number of Children',
  DEPARTURE: 'Departure',
  DEPARTURE_MONTHS: 'Departure Months',
  
};

export const filterStepsTypes = {
  PRIMARY_CLASSIFICATIONS: 'primary-classifications',
  SECONDARY_CLASSIFICATIONS: 'secondary-classifications',
  HOTEL_PRODUCTS: 'hotel-products',
  DESTINATION_TRAITS_SELECTION: 'destination-traits-options',
  DESTINATION_TRAITS_DETAILS: 'destination-traits-details',
};

export const filterSteps = [
  {
    index: 0,
    id: filterStepsTypes.PRIMARY_CLASSIFICATIONS,
    name: selectablesNames.PRIMARY_CLASSIFICATIONS,
  },
  {
    index: 1,
    id: filterStepsTypes.SECONDARY_CLASSIFICATIONS,
    name: selectablesNames.SECONDARY_CLASSIFICATIONS,
  },
  {
    index: 2,
    id: filterStepsTypes.HOTEL_PRODUCTS,
    name: selectablesNames.HOTEL_PRODUCTS,
  },
  {
    index: 3,
    id: filterStepsTypes.DESTINATION_TRAITS_SELECTION,
    name: selectablesNames.DESTINATION_TRAITS_SELECTION,
  },
  {
    index: 4,
    id: filterStepsTypes.DESTINATION_TRAITS_DETAILS,
    name: selectablesNames.DESTINATION_TRAITS_DETAILS,
  },
];

export const toolPanelOptionIds = {
  ACTIVITIES: 'activities',
  ACCOMMODATION: 'accommodation',
  TRAITS: 'traits',
  PAX: 'pax',
  CALENDAR: 'calendar',
};

export const resultTypes = {
  ALL: 'all',
  HOTELS: 'hotels',
  DESTINATIONS: 'destinations',
  EXCURSIONS: 'excursions',
  GROUP_TRIPS: 'grouptrips',
  ARTICLES: 'articles',
};

export const tipTypes = {
  DESTINATION: 'destination',
  EXCURSION: 'excursion',
  GROUP_TRIP: 'grouptrip',
};

export const locationEnums = {
  ASIA: 'ASIA',
  AFRICA: 'AFRICA',
  CANARY_ISLANDS: 'CANARY_ISLANDS',
  CARIBEAN_CENTRAL_AMERICA: 'CARIBEAN_CENTRAL_AMERICA',
  EUROPE: 'EUROPE',
  NORTH_AMERICA: 'NORTH_AMERICA',
  SOUTH_AMERICA: 'SOUTH_AMERICA',
  ANYWHERE: 'ANYWHERE',
}

export const temperatureGroups = {
  warm: {
    minTemp: 26,
  },
  medium: {
    minTemp: 20,
    maxTemp: 25,
  },
  cool: {
    maxTemp: 19,
  },
};

// Depending on the selected season, we will search for temperature for a specific month
export const temperatureMonthBySeason = {
  spring: 4,  // April
  summer: 7,  // July
  autumn: 10, // October
  winter: 1,  // January
};

export const flightTimeToRegion = {
  short: [
    locationEnums.EUROPE,
  ],
  medium: [
    locationEnums.CANARY_ISLANDS,
    locationEnums.AFRICA,
  ],
  long: [
    locationEnums.ASIA,
    locationEnums.NORTH_AMERICA,
    locationEnums.SOUTH_AMERICA,
    locationEnums.CARIBEAN_CENTRAL_AMERICA,
  ],
};

export const siteIdToMucd = {
  1: 'VS',
  3: 'VN',
  11: 'SD',
  15: 'TF',
  18: 'DS',
};

export const paxSettings = {
  minNumberOfAdults: 1,
  maxNumberOfAdults: 2,
  minNumberOfChildren: 0,
  maxNumberOfChildren: 3,
  defaultSelectedNumberOfAdults: 2,
  defaultSelectedNumberOfChildren: 0,
};

export const calendarSettings = {
  maxBookMonthsAhead: 16,
};

export const defaultListCount = 2;

export const initListLengths = {
  [resultTypes.ALL]: 2,
  [resultTypes.HOTELS]: 6,
  [resultTypes.DESTINATIONS]: 6,
  [resultTypes.EXCURSIONS]: 6,
  [resultTypes.GROUP_TRIPS]: 5,
};

export const resultListClickedItemKey = 'vfPreNavScrollPos';
